<template>
	<div class="cgly-main">
		<div class="cgly-top">
			<div class="cgly-top-left">
				<div class="bj-icon">
					<i class="iconfont iconbianji"></i>
				</div>
				发布我的参观留言
			</div>
			<div class="cgly-top-right" v-if="userId">

			</div>
			<div class="cgly-top-right" v-else>
				<div style="width: 40px; text-align: center; cursor: pointer;" class="pointer-color" @click="toLogin">
					登录
				</div>
				<div style="width: 10px; text-align: center; color: #264EA7;">
					|
				</div>
				<div style="width: 40px; text-align: center; cursor: pointer;" class="pointer-color" @click="toRegister">
					注册
				</div>
			</div>
		</div>
		<div class="cgly-box">
			<div class="cgly-box-top">
				<div class="cgly-box-top-left">
					留言人:
				</div>
				<div class="cgly-box-top-right">
					<Input v-model="content.name" style="width: 100%;"></Input>
				</div>
			</div>
			<div class="cgly-box-bottom">
				<div class="cgly-box-bottom-left">
					留言内容:
				</div>
				<div class="cgly-box-bottom-right">
					<Input v-model="content.content" type="textarea" style="width: 100%;" :rows="10" placeholder="中国人民解放军海军博物馆,欢迎您的留言!"></Input>
				</div>
			</div>
			<div class="cgly-box-tip">
				<div class="cgly-box-tip-left">
					请遵守言论规则，不得违反国家法律法规
				</div>
				<Button class="cgly-box-tip-right" @click="push" :loading="pushLoading">
					发布
				</Button>
			</div>
		</div>
		<div class="cgly-list" v-if="visitList.length > 0">
			<div class="cgly-list-item" v-for="(item, index) in visitList" :key="index">
				<div class="cgly-list-item-top">
					<span>
						{{item.name}}
					</span>
					<span style="margin-left: 5px;">
						{{item.createdTime}}
					</span>
				</div>
				<div class="cgly-list-item-content">
					{{item.content}}
				</div>
				<div class="cgly-list-item-reply" v-if="item.replyContent">
					<img src="../../../static/gou.png" style="width: 22px; height: 22px; margin-right: 10px;">
					{{item.replyContent}}
				</div>
			</div>
		</div>
		<div>
			<page :pageObj="params" @getDataList="getData" ref="page"></page>
		</div>
	</div>
</template>

<script>
	import Page from '@/components/Page.vue'
	export default {
		name: '',
		components: {
			Page,
		},
		data() {
			return {
				visitList: [],
				params: {
					current: 1,
					size: 5,
					url: '/api/visitMsg/findVisitList'
				},
				userId: "",
				content: {
					name: "",
					content: ""
				},
				pushLoading: false
			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = ''
			that.getUserInfo()
		},
		methods: {
			getUserInfo() {
				let that = this
				that.userId = that.$http.getStorage('userId')
			},
			getData(visit) {
				document.body.scrollTop = document.documentElement.scrollTop = 0
				this.visitList = visit
			},
			toLogin() {
				this.$router.push({
					path: '/login',
					query: {
						redirect: 'cgly'
					}
				})
			},
			toRegister() {
				this.$router.push({
					path: '/register',
					query: {
						redirect: 'cgly'
					}
				})
			},
			push() {
				let that = this
				if(!that.content.name) {
					that.$Message.error('请输入留言者姓名')
					return
				}
				if(!that.content.content) {
					that.$Message.error('请输入留言内容')
					return
				}
				that.pushLoading = true
				that.$http.post({
					url: `/api/visitMsg/addVisitMsg`,
					data: {
						name: that.content.name,
						content: that.content.content
					}
				}).then(res => {
					if(res.code === 'S200') {
						that.$Message.success('发布成功！')
						that.pushLoading = false
						that.content = {
							name: "",
							content: ""
						}
						that.visitList = []
						that.$refs.page.getData()
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.cgly-main {
		width: 74%;
		margin: 30px 13% 40px;
		.cgly-top {
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			height: 40px;
			line-height: 40px;
			font-size: 16px;
			.cgly-top-left {
				display: flex;
				color: #264EA7;
				font-weight: 400;
				width: 50%;
				.bj-icon {
					margin-right: 5px;
					i {
						font-size: 26px;
						font-weight: 400;
					}
				}
			}
			.cgly-top-right {
				display: flex;
				font-size: 14px;
				color: #777;
				width: 50%;
				justify-content: right;
				.pointer-color:hover {
					color: #264EA7;
				}
			}
		}
		.cgly-box {
			width: 100%;
			padding: 20px 5%;
			background-color: rgb(241, 246,255);
			margin-top: 10px;
			border-left: 1px solid rgb(231, 231, 231);
			border-right: 1px solid rgb(231, 231, 231);
			.cgly-box-top {
				display: flex;
				justify-content: space-between;
				height: 40px;
				line-height: 40px;
				.cgly-box-top-left {
					width: 100px;
					text-align: left;
				}
				.cgly-box-top-right {
					width: calc(100% - 120px);
				}
			}
			.cgly-box-bottom {
				margin-top: 20px;
				display: flex;
				justify-content: space-between;
				line-height: 40px;
				.cgly-box-bottom-left {
					width: 100px;
					text-align: left;
				}
				.cgly-box-bottom-right {
					width: calc(100% - 120px);
				}
			}
			.cgly-box-tip {
				margin-top: 20px;
				display: flex;
				justify-content: space-between;
				.cgly-box-tip-left {
					margin-left: 120px;
					color: rgb(113, 113, 113);
				}
				.cgly-box-tip-right {
					height: 40px;
					width: 100px;
					line-height: 40px;
					font-size: 16px;
					background-color: rgb(38, 78, 167);
					color: #FFFFFF;
					cursor: pointer;
				}
			}
		}
		.cgly-list {
			width: 100%;
			border: 1px solid rgb(231, 231, 231);
			.cgly-list-item {
				width: 90%;
				margin: 20px 5% 30px;
				display: flex;
				flex-direction: column;
				.cgly-list-item-top {
					text-align: left;
					color: rgb(165, 165, 165);
					font-size: 16px;
				}
				.cgly-list-item-content {
					margin-top: 10px;
					text-align: left;
					font-size: 16px;
					word-wrap:break-word;
				}
				.cgly-list-item-reply {
					display: flex;
					margin-top: 10px;
					border: 1px solid rgb(214, 225, 244);
					background-color: rgb(241, 246, 255);
					padding: 10px;
					text-align: left;
					font-size: 16px;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/cgly/cgly.vue